// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React from 'react';
import { Table } from 'react-bootstrap';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/prop-types
const BookingOptionsPreview = ({ activities, bookingOptions }) => {
  const renderTbody = () => (
    <tbody>
      {/* TODO: Fix this the next time the file is edited. */}
      {/* eslint-disable-next-line react/prop-types */}
      {bookingOptions?.map(item => (
        <tr key={item.bookingOptionTitle + item.duration}>
          <td>{item.productSlug}</td>
          <td>
            {/* TODO: Fix this the next time the file is edited. */}
            {/* eslint-disable-next-line react/prop-types */}
            {activities?.find(activity => activity.productId === item.productId)
              ?.title || ''}
          </td>
          <td>{item.bookingOptionTitle}</td>
          <td>{item.bookingOptionDescription}</td>
          <td>{item.bookingOptionDuration}</td>
          <td>{item.bookingOptionHours}</td>
          <td>{item.bookingOptionInterval}</td>
          <td>{item.bookingOptionPrice}</td>
          <td>{item.bookingOptionPricingModel}</td>
          <td>{item.bookingOptionSubtype}</td>
          <td>{item.taxCode}</td>
          <td>{item.bookingOptionGratuity}</td>
          <td>{item.bookingOptionVendorFees}</td>
          <td>{item.bookingOptionAttendeesRequired}</td>
          <td>{item.bookingOptionAttendeesMinimum}</td>
          <td>{item.bookingOptionAttendeesMaximum}</td>
          <td>{item.bookingOptionBookingNotes}</td>
          <td>{item.locationType}</td>
          <td>{item.bookingOptionAddress}</td>
        </tr>
      ))}
    </tbody>
  );

  return (
    <>
      {/* TODO: Fix this the next time the file is edited. */}
      {/* eslint-disable-next-line react/prop-types */}
      {bookingOptions && bookingOptions.length ? (
        <div className='table-responsive'>
          <Table>
            <thead>
              <tr>
                <th>Product Slug</th>
                <th className={'table-cell__lg'}>Activity</th>
                <th>Title</th>
                <th className={'table-cell__lg'}>Description</th>
                <th>Duration</th>
                <th>Hours</th>
                <th>Interval</th>
                <th>Price</th>
                <th>Pricing Model</th>
                <th>Subtype</th>
                <th>Gratuity</th>
                <th>Vendor Fees</th>
                <th className={'table-cell__lg'}>Attendees Required</th>
                <th>Min Attendees</th>
                <th>Max Attendees</th>
                <th>Booking Notes</th>
                <th>Location Type</th>
                <th>Address</th>
              </tr>
            </thead>
            {renderTbody()}
          </Table>
        </div>
      ) : (
        <p>No data</p>
      )}
    </>
  );
};

export default React.memo(BookingOptionsPreview);
